import { ref, onMounted, onUnmounted, watch } from 'vue';

const MAX_TIMEOUT_MS = 604800000;

export function useInactivity(timeoutRef) {
  const isIdle = ref(false);
  let timeoutId = null;
  let lastActivityAt = Date.now();

  const clearTimer = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  const scheduleDeadline = () => {
    clearTimer();
    const timeoutMs = Number(timeoutRef.value);
    if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) return;

    const remainingMs = lastActivityAt + timeoutMs - Date.now();
    if (remainingMs <= 0) {
      isIdle.value = true;
      return;
    }

    timeoutId = setTimeout(
      () => {
        scheduleDeadline();
      },
      Math.min(remainingMs, MAX_TIMEOUT_MS)
    );
  };

  const resetTimer = () => {
    lastActivityAt = Date.now();
    isIdle.value = false;
    scheduleDeadline();
  };

  const checkDeadline = () => {
    if (!document.hidden) scheduleDeadline();
  };

  const activityEvents = [
    'pointerdown',
    'pointermove',
    'keydown',
    'scroll',
    'touchstart',
  ];

  onMounted(() => {
    activityEvents.forEach(event =>
      window.addEventListener(event, resetTimer, event === 'scroll')
    );
    window.addEventListener('focus', checkDeadline);
    document.addEventListener('visibilitychange', checkDeadline);
    resetTimer();
  });

  onUnmounted(() => {
    activityEvents.forEach(event =>
      window.removeEventListener(event, resetTimer, event === 'scroll')
    );
    window.removeEventListener('focus', checkDeadline);
    document.removeEventListener('visibilitychange', checkDeadline);
    clearTimer();
  });

  watch(timeoutRef, resetTimer);

  return { isIdle, resetTimer };
}
